import { t } from 'i18next';
import { css, html, LitElement } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { createRef, Ref, ref } from 'lit/directives/ref.js';

import { FgDialog } from '@/components';
import { baseStyles, buttonStyles, typographyStyles } from '@/styles';

@customElement('fg-remove-token-dialog')
export class FgRemoveTokenDialog extends LitElement {
  private fgDialogRef: Ref<FgDialog> = createRef();

  @state()
  private tokenId?: string;

  openDialog(tokenId: string) {
    this.tokenId = tokenId;
    this.fgDialogRef.value?.open();
  }

  closeDialog() {
    this.fgDialogRef.value?.close();
  }

  render() {
    return html`
      <fg-dialog part="wholesale" ${ref(this.fgDialogRef)} compact closable>
        <div slot="title">${t('content.debtorToken.removeDialog.title')}</div>
        <div class="body">
          <div>${t('content.debtorToken.removeDialog.content')}</div>
          <div class="actions">
            <button
              class="button button-tertiary"
              @click="${() => this.closeDialog()}"
            >
              ${t('actions.cancel')}
            </button>
            <button
              class="button button-primary"
              @click="${() =>
                this.dispatchEvent(
                  new CustomEvent('delete-token', {
                    detail: {
                      tokenId: this.tokenId,
                    },
                  }),
                )}"
            >
              ${t('actions.delete')}
            </button>
          </div>
        </div>
      </fg-dialog>
    `;
  }

  static styles = [
    baseStyles,
    typographyStyles,
    buttonStyles,
    css`
      .actions {
        width: 100%;
        gap: 16px;
        display: flex;
      }

      .button {
        width: 100%;
      }

      .body {
        gap: 24px;
        display: flex;
        flex-direction: column;
      }
    `,
  ];
}
